
import React from 'react';
import { Gift } from 'lucide-react';

interface GiftCardCTAProps {
  className?: string;
}

const GiftCardCTA: React.FC<GiftCardCTAProps> = ({ className }) => {
  return (
    <section className={`py-12 bg-gradient-to-r from-[#C58B65]/20 to-[#8B4E2E]/20 ${className}`}>
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <div className="bg-white rounded-lg shadow-md p-8 border border-[#C58B65]/30">
            <div className="inline-flex items-center justify-center p-3 bg-[#C58B65]/10 rounded-full mb-4">
              <Gift className="h-8 w-8 text-[#C58B65]" />
            </div>
            <h3 className="text-2xl md:text-3xl font-playfair font-bold mb-4 text-primary">
              Give the Gift of Cat History
            </h3>
            <p className="mb-6 text-lg">
              Make a cat lover's day with a unique NYC experience they'll treasure forever—perfect for birthdays, holidays, or any special moment!
            </p>
            <a 
              href="https://fareharbor.com/embeds/book/catsabouttown/items/562633/calendar/?full-items=yes&flow=1219724" 
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#C46829] text-white hover:text-white px-6 py-3 rounded font-semibold hover:bg-[#B35718] transition-all duration-300 hover:scale-105 inline-flex items-center min-h-[48px] min-w-[200px] justify-center"
            >
              <Gift className="mr-2 h-5 w-5" />
              Purchase a Gift Card
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GiftCardCTA;
